import type { MeterView } from "../api/types";
import { transportLabels } from "../api/types";
import { StatusBadge } from "./StatusBadge";

interface Props {
  meters: MeterView[];
  selectedId: number | null;
  onSelect: (id: number) => void;
}

export function MeterList({ meters, selectedId, onSelect }: Props) {
  if (!meters.length) {
    return <div className="muted">Счётчики не найдены. Проверьте конфиг сервиса.</div>;
  }

  return (
    <div className="meter-list">
      {meters.map((m) => (
        <button
          key={m.id}
          type="button"
          className="meter-card"
          aria-current={m.id === selectedId}
          onClick={() => onSelect(m.id)}
        >
          <div className="row">
            <span className="name">{m.name}</span>
            <span className="power">
              {fmt(m.latest.power_active, 1)}
              <span className="unit">кВт</span>
            </span>
          </div>
          <div className="row">
            <span className="sub">{m.location || m.serial}</span>
          </div>
          <div className="row" style={{ marginTop: 4, gap: 6 }}>
            <StatusBadge state={m.state} />
            <span className="badge">{transportLabels[m.transport] ?? m.transport}</span>
            {/* Адрес на шине: по нему точку находят в шкафу. Slug для этого не
                годится — он исторический и с адресом уже расходится. */}
            {m.unitId > 0 && (
              <span className="badge" title="Адрес прибора на шине RS-485">
                адрес {m.unitId}
              </span>
            )}
          </div>
        </button>
      ))}
    </div>
  );
}

function fmt(v: number | undefined, digits: number): string {
  if (v === undefined || Number.isNaN(v)) return "—";
  return v.toLocaleString("ru-RU", { minimumFractionDigits: digits, maximumFractionDigits: digits });
}
